import moment from 'moment'
import { useState } from 'react'
import { ASSESSMENT_STATUSES, ASSESSMENT_URL } from 'services/constants'
import { patchRequest } from 'utils/api'
import NotificationSnackBar from '../notificationOverlay/NotificationSnackBar'
import CommonDialog from '../notificationOverlay/CommonDialog'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import OverlayLoading from 'components/atoms/OverlayLoading'
import SmallButton from 'components/atoms/button/SmallButton'
import { Typography } from '@mui/material'

const ReOpenAssessmentButton = ({ assessment, email }) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [reopened, setReopened] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleReOpen = async confirmed => {
    if (confirmed) {
      setLoading(true)
      const res = await patchRequest(`${ASSESSMENT_URL}/${assessment.id}`, {
        status: ASSESSMENT_STATUSES.OPEN,
        sendAt: moment.utc()
      })
      if (res.status === 200) {
        setDialogOpen(false)
        setSuccess(true)
        setReopened(true)
      } else {
        setError(true)
      }
      setLoading(false)
    } else {
      setDialogOpen(false)
    }
  }
  return (
    <>
      <Typography variant='body1Small'>
        {assessment.isOpen ? 'Open' : reopened ? 'Re-opened' : 'Closed'}
      </Typography>
      {!reopened && !assessment.isOpen && assessment.raters?.length > 0 && (
        <SmallButton onClick={() => setDialogOpen(true)}>Re-open</SmallButton>
      )}
      <CommonDialog
        open={dialogOpen}
        onClose={handleReOpen}
        notificationText={`You are re-opening ${email}'s 360 assessment requests. This will send out requests to those who hasn’t completed the request yet. This will extend the closing date for 2 weeks from now`}
        confirmText='Reopen'
        cancelText='Cancel'
        >
        {error && <RequestRetryAlert />}
      </CommonDialog>
      <NotificationSnackBar
        open={success}
        setOpen={setSuccess}
        success={true}
        autoHideDuration={2000}
      />
      <OverlayLoading open={loading} />
    </>
  )
}

export default ReOpenAssessmentButton
